"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFormDataWithValidationUtil = exports.updateFormDataWithValidationUtil = exports.getFormDataOrRepopulateUtil = exports.resetForm = exports.receiveFormData = exports.invalidateForm = exports.discardChanges = exports.setFormEditableState = exports.setFieldValidation = exports.setFormFieldValue = exports.FORM_REPOPULATE = exports.FORM_RESET = exports.FORM_INVALIDATE_FIELDS = exports.FORM_SAVE_DATA = exports.FORM_RECEIVE_DATA = exports.FORM_SAVE_IN_PROGRESS = exports.FORM_FETCH_IN_PROGRESS = exports.FORM_SAVING_ERROR = exports.FORM_FETCHING_ERROR = exports.FORM_DISCARD_CHANGES = exports.FORM_SET_EDITABLE_STATE = exports.FORM_SET_FIELD_VALIDATION = exports.FORM_SET_FIELD_VALUE = void 0;

var _reduxBatchedActions = require("redux-batched-actions");

var _index = require("./index");

var _messages = require("../messages");

var FORM_SET_FIELD_VALUE = 'FORM_SET_FIELD_VALUE';
exports.FORM_SET_FIELD_VALUE = FORM_SET_FIELD_VALUE;
var FORM_SET_FIELD_VALIDATION = 'FORM_SET_FIELD_VALIDATION';
exports.FORM_SET_FIELD_VALIDATION = FORM_SET_FIELD_VALIDATION;
var FORM_SET_EDITABLE_STATE = 'FORM_SET_EDITABLE_STATE';
exports.FORM_SET_EDITABLE_STATE = FORM_SET_EDITABLE_STATE;
var FORM_DISCARD_CHANGES = 'FORM_DISCARD_CHANGES';
exports.FORM_DISCARD_CHANGES = FORM_DISCARD_CHANGES;
var FORM_FETCHING_ERROR = 'FORM_FETCHING_ERROR';
exports.FORM_FETCHING_ERROR = FORM_FETCHING_ERROR;
var FORM_SAVING_ERROR = 'FORM_SAVING_ERROR';
exports.FORM_SAVING_ERROR = FORM_SAVING_ERROR;
var FORM_FETCH_IN_PROGRESS = 'FORM_FETCH_IN_PROGRESS';
exports.FORM_FETCH_IN_PROGRESS = FORM_FETCH_IN_PROGRESS;
var FORM_SAVE_IN_PROGRESS = 'FORM_SAVE_IN_PROGRESS';
exports.FORM_SAVE_IN_PROGRESS = FORM_SAVE_IN_PROGRESS;
var FORM_RECEIVE_DATA = 'FORM_RECEIVE_DATA';
exports.FORM_RECEIVE_DATA = FORM_RECEIVE_DATA;
var FORM_SAVE_DATA = 'FORM_SAVE_DATA';
exports.FORM_SAVE_DATA = FORM_SAVE_DATA;
var FORM_INVALIDATE_FIELDS = 'FORM_INVALIDATE_FIELDS';
exports.FORM_INVALIDATE_FIELDS = FORM_INVALIDATE_FIELDS;
var FORM_RESET = 'FORM_RESET';
exports.FORM_RESET = FORM_RESET;
var FORM_REPOPULATE = 'FORM_REPOPULATE';
exports.FORM_REPOPULATE = FORM_REPOPULATE;

var setFormFieldValue = function setFormFieldValue(formName, fieldName, value) {
  return {
    type: FORM_SET_FIELD_VALUE,
    formName: formName,
    fieldName: fieldName,
    value: value
  };
};

exports.setFormFieldValue = setFormFieldValue;

var setFieldValidation = function setFieldValidation(formName, fieldName, validationStatus) {
  return {
    type: FORM_SET_FIELD_VALIDATION,
    formName: formName,
    fieldName: fieldName,
    validationStatus: validationStatus
  };
};

exports.setFieldValidation = setFieldValidation;

var setFormEditableState = function setFormEditableState(formName, isEditable) {
  return {
    type: FORM_SET_EDITABLE_STATE,
    formName: formName,
    isEditable: isEditable
  };
};

exports.setFormEditableState = setFormEditableState;

var discardChanges = function discardChanges(formName) {
  return {
    type: FORM_DISCARD_CHANGES,
    formName: formName
  };
};

exports.discardChanges = discardChanges;

var invalidateForm = function invalidateForm(formName) {
  return {
    type: FORM_INVALIDATE_FIELDS,
    formName: formName
  };
}; // ACTION CREATORS FOR THUNKS


exports.invalidateForm = invalidateForm;

var receiveFormData = function receiveFormData(formName, formData) {
  return {
    type: FORM_RECEIVE_DATA,
    formName: formName,
    formData: formData
  };
};

exports.receiveFormData = receiveFormData;

var saveFormData = function saveFormData(formName, formData) {
  return {
    type: FORM_SAVE_DATA,
    formName: formName,
    formData: formData
  };
};

var formSaveingError = function formSaveingError(formName, isAuthForm) {
  return {
    type: FORM_SAVING_ERROR,
    formName: formName,
    isAuthForm: isAuthForm
  };
};

var formFetchingError = function formFetchingError(formName) {
  return {
    type: FORM_FETCHING_ERROR,
    formName: formName
  };
};

var formFetchInProgerss = function formFetchInProgerss(formName) {
  return {
    type: FORM_FETCH_IN_PROGRESS,
    formName: formName
  };
};

var formSaveInProgress = function formSaveInProgress(formName) {
  return {
    type: FORM_SAVE_IN_PROGRESS,
    formName: formName
  };
};

var resetForm = function resetForm(formName) {
  return {
    type: FORM_RESET,
    formName: formName
  };
};

exports.resetForm = resetForm;

var repopulateForm = function repopulateForm(formName) {
  return {
    type: FORM_REPOPULATE,
    formName: formName
  };
}; // THUNK CREATORS


var getFormData = function getFormData(formName, fetchFormDataCallUtil, id, message) {
  return function (dispatch) {
    dispatch(formFetchInProgerss(formName));
    return fetchFormDataCallUtil(id ? id : null).then(function (response) {
      return dispatch(receiveFormData(formName, response.data));
    }).catch(function () {
      return dispatch(formFetchingErrorWithMessage(formName, message));
    });
  };
};

var updateFormData = function updateFormData(formName, patchFormDataCallUtil, updatedFormData, id, successAction, failAction, resetForm, message) {
  return function (dispatch) {
    dispatch(formSaveInProgress(formName));
    return patchFormDataCallUtil(updatedFormData, formName, id).then(function (response) {
      dispatch((0, _reduxBatchedActions.batchActions)([saveFormData(formName, response.data), (0, _messages.displaySuccessMessage)(message.success)]));
      if (successAction) successAction(response);
    }).catch(function (error) {
      dispatch(formSavingErrorWithMessage(formName, message.error, resetForm));
      if (failAction) failAction(error.response);
    });
  };
};

var createFormData = function createFormData(formName, postFormDataCallUtil, formDataToSave, successAction, failAction, resetForm, message) {
  return function (dispatch) {
    dispatch(formSaveInProgress(formName));
    return postFormDataCallUtil(formDataToSave).then(function (response) {
      //we are not firing success messages when signing up or signing in, only on fail
      if (!!message.success) {
        dispatch((0, _reduxBatchedActions.batchActions)([saveFormData(formName, response.data), (0, _messages.displaySuccessMessage)(message.success)]));
      } else {
        dispatch(saveFormData(formName, response.data));
      }

      if (successAction) successAction(response);
    }, function (error) {
      dispatch(formSavingErrorWithMessage(formName, message.error, resetForm));
      if (failAction) failAction(error.response);
    });
  };
};

var formFetchingErrorWithMessage = function formFetchingErrorWithMessage(formName, errorMessage) {
  return (0, _reduxBatchedActions.batchActions)([formFetchingError(formName), (0, _messages.displayErrorMessage)(errorMessage)]);
};

var formSavingErrorWithMessage = function formSavingErrorWithMessage(formName, errorMessage, resetForm) {
  return !errorMessage ? formSaveingError(formName, resetForm) : (0, _reduxBatchedActions.batchActions)([formSaveingError(formName, resetForm), (0, _messages.displayErrorMessage)(errorMessage)]);
};

var getFormDataOrRepopulateUtil = function getFormDataOrRepopulateUtil(formName, fetchFormDataCallUtil, hasStoredData, id, message) {
  return hasStoredData ? repopulateForm(formName) : getFormData(formName, fetchFormDataCallUtil, id, message);
};

exports.getFormDataOrRepopulateUtil = getFormDataOrRepopulateUtil;

var updateFormDataWithValidationUtil = function updateFormDataWithValidationUtil(formName, fields, patchFormDataCallUtil, updatedFormData, id, successAction, failAction, resetForm, message) {
  return (0, _index.isFormValid)(fields) ? updateFormData(formName, patchFormDataCallUtil, updatedFormData, id, successAction, failAction, resetForm, message) : invalidateForm(formName);
};

exports.updateFormDataWithValidationUtil = updateFormDataWithValidationUtil;

var createFormDataWithValidationUtil = function createFormDataWithValidationUtil(formName, fields, patchFormDataCallUtil, updatedFormData, successAction, failAction, resetForm, message) {
  return (0, _index.isFormValid)(fields) ? createFormData(formName, patchFormDataCallUtil, updatedFormData, successAction, failAction, resetForm, message) : invalidateForm(formName);
};

exports.createFormDataWithValidationUtil = createFormDataWithValidationUtil;